import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";

import { round } from "lodash";
import { useTranslation } from "react-i18next";
import { useDataGridSettings } from "@/components/DataGridSettingsProvider";
import { useGetColorByValue } from "@/pages/diagnosticmonitor/hooks/useGetColorByValue";

interface OdometerCellProps {
  props: GridRenderCellParams;
}

export function OdometerCell({ props }: OdometerCellProps) {
  const { field, value } = props;
  const { precisions } = useDataGridSettings();
  const { t } = useTranslation();

  const formattedValue =
    value !== null
      ? `${round(value, precisions?.["odometer"] ?? 0).toLocaleString("de-DE", {
          minimumFractionDigits: precisions?.["odometer"] ?? 0,
          maximumFractionDigits: precisions?.["odometer"] ?? 0,
        })} ${t("units.km")}`
      : "";

  const getColorByValue = useGetColorByValue();
  const { bgColor, color } = getColorByValue(field, value);

  return (
    <Tooltip
      sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      title={formattedValue}
    >
      <Box
        color={value ? color : "#000"}
        sx={{
          backgroundColor: value ? bgColor : undefined,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "100%",
        }}
      >
        {formattedValue || "---"}
      </Box>
    </Tooltip>
  );
}
